import * as React from 'react';

export interface LoginComponentProps {
  error: boolean;
  errorMessage: {};
  register: () => void;
}

const messageValues: { [s: string]: string; } = {
  serverConnection: 'serverConnection',
  email: 'email'
};

const LoginErrorMessagesComponent = (props: LoginComponentProps) => {

  const message = (messages: {}): React.ReactNode => {
    if (Object.keys(messages).lastIndexOf(messageValues.serverConnection) !== -1) {
      return (
        <div>
          <span className="arrow-right-primary-dark" />
            {messages[messageValues.serverConnection]}
        </div>
      );
    }

    if (typeof messages === 'object' && Object.keys(messages).lastIndexOf(messageValues.email) !== -1) {
      return (
        <div>
          <span className="arrow-right-primary-dark" />
          El email introducido no tiene un formato correcto, por favor introdúzcalo
          <br/>
          de nuevo o&nbsp;
          <a
            className="pointer"
            onClick={() => props.register()}
          >
            regístrese.
          </a>
        </div>
      );
    } else {
      return (
        <div>
          <span className="arrow-right-primary-dark" />
          <strong>Credenciales incorrectas, por favor introdúzcalas
          <br/>
          de nuevo o&nbsp;
          <a
            className="pointer"
            onClick={() => props.register()}
          >
            regístrese.
          </a>
          </strong>
        </div>
      );
    }
  };

  return (
    <div>
      {props.error ? message(props.errorMessage) : null}
    </div>
  );
};

export default LoginErrorMessagesComponent;



// WEBPACK FOOTER //
// ./src/modules/modals/login/partials/LoginErrorMessages.component.tsx